<div class="h-[calc(100vh-68px)] flex justify-center items-center">
  <app-user-reset-password-form></app-user-reset-password-form>
</div>
